// src/supabaseClient.ts
import { createClient } from '@supabase/supabase-js'

console.log('ALL AVAILABLE ENV VARIABLES:', process.env);

// These variables are now read directly from your .env file
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and anon key are required in your .env file.');
}

// Create and export the Supabase client for the front-end
export const supabase = createClient(supabaseUrl, supabaseAnonKey)